// extracted by mini-css-extract-plugin
export default {"totop":"styles_totop__8qatl"};